<template>
    <div class="panel-body">
      <template>
        <v-card width="1000px">
        <v-data-table
          v-model="memberModel"
          :headers="head1"
          :items="member"
          item-key="id"
          class="elevation-1"
          :rows-per-page="rowsPerPage"
          :items-per-page-options="rppItems"
        >
        <template slot="item" slot-scope="props">
          <tr>
            <td class="text-xs-center" width="500px">{{ props.item.userEmail }}</td>
            <td class="text-xs-center" width="500px">{{ props.item.userId }}</td>
            <td class="text-xs-center" width="500px">{{ props.item.userRole }}</td>
            <td class="text-xs-center" width="500px">{{ props.item.status }}</td>
            <td class="text-xs-center" width="500px">{{ formatDate(props.item.invitedOn) }}</td>
            <td class="text-xs-center" width="500px">{{ formatDate(props.item.joinedOn) }}</td>
            </tr>
        </template>
        <template slot="no-data">
        </template>
      </v-data-table>
      </v-card>
      </template>
    </div>
  </template>

<script>
import moment from 'moment'
let rh = require('@/components/APIs/RequestHandler')
export default {
  props: {
    jarId: {
      type: Number,
      required: true
    },
    userId: {
      type: Number,
      required: true
    }

  },
  data: () => ({
    loadingMember: false,
    rppItems: [
      10,
      50,
      100,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    rowsPerPage: 10,
    memberModel: [],
    errors: [],
    head1: [
      { text: 'User Email', align: 'left', sortable: false, value: 'userEmail' },
      { text: 'User ID', align: 'left', sortable: false, value: 'userId' },
      { text: 'Role', align: 'left', sortable: false, value: 'userRole' },
      { text: 'Status', align: 'left', sortable: false, value: 'status' },
      { text: 'Invited On', align: 'left', value: 'invitedOn' },
      { text: 'Joined On', align: 'left', value: 'joinedOn' }
    ],
    member: []
  }),
  created () {
    this.loadMember()
  },
  mounted () {
    this.loadMember()
  },
  watch: {
    jarId: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.loadMember()
      }
    }
  },

  methods: {

    async loadMember () {
      if (this.userId == null || this.userId === '' || this.jarId == null || this.jarId === '') {
        // console.log('User ID or Jar ID not set, unable to load jar Member')
        this.member = []
        return
      }
      // this.loadingMember = true
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_JAR}/jars/group-members?jarId=${this.jarId}&status=ACCEPTED,INVITED,INVITE_FAIL,ACTIVE,COMPLETED,DELETED,CASHED_OUT`

      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      if (getResponse === undefined) { this.member = [] } else { this.member = getResponse.data }
      // this.loadingMember = false
    },

    formatDate (aDate) {
      return moment(String(aDate)).format('MM/DD/YYYY hh:mm:ss')
    }
  }
}
</script>
<style>
</style>
